<template>
  <van-checkbox v-model="checkValue" :bindGroup="false" @change="updateValue">
    <template #icon>
      <em v-if="checkValue" class="iconfont icon-dui checkbox-check"></em>
      <em v-else class="iconfont icon-uncheck checkbox-uncheck"></em>
    </template>
    <slot></slot>
  </van-checkbox>
</template>

<script>
export default {
  name: 'SingleCheckbox',
  emits: ['update:value'],
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      checkValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.checkValue = newValue;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  &-uncheck,
  &-check {
    font-size: 38px;
  }
  &-uncheck {
    color: var(--text-color);
  }
  &-check {
    position: relative;
    color: var(--main-color);
    &::before {
      position: relative;
      z-index: 2;
    }
    &::after {
      z-index: 1;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 34px;
      height: 34px;
      background-color: #fff;
      border-radius: 50%;
    }
  }
}
::v-deep .van-checkbox__label {
  font-size: 24px;
  line-height: 40px;
  color: var(--text-color);
}
</style>
